module.exports = "../fonts/HelveticaNeueLTW01-35Thin.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-35Thin.woff
// module id = 2iCl
// module chunks = 1